import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
export function Loader(t0) {
  const $ = _c(14);
  const {
    size: t1,
    className: t2,
    color
  } = t0;
  const size = t1 === undefined ? "large" : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `flex justify-center h-full items-center ${className}`;
  let t4;
  if ($[0] !== color) {
    t4 = color ? {
      color
    } : undefined;
    $[0] = color;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== size) {
    t5 = size === "large" && <i className="line-md-loading-loop w-[50px] h-[50px]" />;
    $[2] = size;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== size) {
    t6 = size === "medium" && <i className="line-md-loading-loop w-[24px] h-[24px]" />;
    $[4] = size;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== size) {
    t7 = size === "small" && <i className="line-md-loading-loop w-[12px] h-[12px]" />;
    $[6] = size;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = <Box className={t3} sx={t4}>{t5}{t6}{t7}</Box>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}